import { mapGetters, mapActions } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import person from '@/api/person'
import user from '@/api/user'
import role from '@/api/role'
import { settingCountry } from '@/api/setting'
import help from '@/utils/help'

const columns = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'email',
  },
  {
    title: '',
    enTitle: 'Name',
    width: 200,
    dataIndex: 'name',
  },
  // {
  //   title: '',
  //   enTitle: 'Research Interests',
  //   width: 200,
  //   dataIndex: 'sectionList',
  //   slot: 'section'
  // },
  {
    title: '',
    enTitle: 'Roles',
    width: 200,
    dataIndex: 'roleList',
    slot: 'section',
  },
  // {
  //   title: '',
  //   enTitle: 'Published in total',
  //   width: 160,
  //   dataIndex: 'articleNum',
  //   sort: true
  // },
  // {
  //   title: '',
  //   enTitle: 'Reviewed in total',
  //   width: 160,
  //   dataIndex: 'reviewNum',
  //   sort: true
  // },
  {
    title: '',
    enTitle: 'Status',
    width: 80,
    dataIndex: 'enabled',
    slot: 'status',
  },
  {
    title: '',
    enTitle: 'Register Time',
    width: 200,
    dataIndex: 'createTime',
    slot: 'time',
    sort: true,
  },
  // {
  //   title: '',
  //   enTitle: 'Last Review Time',
  //   width: 200,
  //   dataIndex: 'lastReviewTime',
  //   slot: 'time',
  //   sort: true
  // },
  // {
  //   title: '',
  //   enTitle: 'Last Submit Time',
  //   width: 200,
  //   dataIndex: 'lastSubmitTime',
  //   slot: 'time'
  // },
  // {
  //   title: '',
  //   enTitle: 'Created Time',
  //   width: 200,
  //   dataIndex: 'createTime',
  //   slot: 'time'
  // },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]

export default {
  components: {
    SiteSearchGroup,
  },
  data() {
    return {
      columns,
      params: {
        like: '',
        roles: '',
        country: '',
        category: '',
      },
      roleIdListArr: [],
      dataSource: [],
      sectionList: [],
      roles: [],
      countryList: [],
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true,
      },
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      user: 'getUser',
    }),
  },
  async mounted() {
    await this.getRoles()
    await this.getList()
    this.countrySearch()
  },
  methods: {
    ...mapActions(['updateLoading']),
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size,
        roleIdList: this.roleIdListArr.length
          ? this.roleIdListArr.join(',')
          : '',
      })
      this.updateLoading(true)
      const { list, pageIndex, pageSize, total } = await person.getUser(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex,
      })
      this.updateLoading(false)
    },
    async getRoles() {
      this.roles = await role.get({ outSided: true })
    },
    handleClear() {
      this.params.query = ''
      this.roleIdListArr = []
      this.params.countryCode = ''
      this.getList()
    },

    //启用/禁用
    async able(val) {
      const { userId, enabled, userVersion } = val
      await user.setEnabled(userId, !enabled, { version: userVersion })
      let content = 'This User has been abled!'
      if (enabled) {
        content = 'This User has been disabled!'
      }
      this.$message.success({
        title: 'Success',
        content: content,
      })
      this.getList()
    },

    detail(val) {
      help.openWindow(
        `/user-manage/manage-users/${val.id}/personal-information`
      )
    },

    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val,
      })
    },

    async exp() {
      const res = await person.export(this.params)
      help.download(res.url, res.fileName)
    },

    setOrder(val) {
      this.params.sorted = val
      this.getList()
    },
  },
}
